var _defs, _polygon, _path, _path2, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:none;}.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 179.55,
    y1: 853.98,
    x2: 450.01,
    y2: 385.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68cbe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#69cbde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#6ac9d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6dc7b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6dc7b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6dc7b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6dc6aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6ec59b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#6ec485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#6fc269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70bf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70bf44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 678.14,
    y1: 743.37,
    x2: 923.92,
    y2: 317.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 935.16,
    y1: 768.02,
    x2: 1007.04,
    y2: 643.51,
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.71 761.7 112.28 761.7 260.4 460.85 401.57 761.7 491.82 761.7 255.77 273.39 19.71 761.7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M966.5,529.29A165.26,165.26,0,1,1,801.23,364.05,165.27,165.27,0,0,1,966.5,529.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M812.1,699.16l6-5.45a167.69,167.69,0,0,1-16.86.85,165.25,165.25,0,1,1,162.1-133l5.11-4.65,65,59a245.11,245.11,0,0,0,14.91-84.48c0-135.72-110-245.73-245.76-245.73s-245.73,110-245.73,245.73,110,245.73,245.73,245.73a245.4,245.4,0,0,0,75.75-11.95Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "897.81 580.45 1070.61 785.65 965.7 785.65 891.64 705.42 897.81 580.45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a93f6aa06a4ae63454bb9669ce9cea3.svg";
export { ForwardRef as ReactComponent };